module.exports = __webpack_public_path__ + "img/THC201804Atype01.614bf095.jpg";